import { Box, Typography } from "@mui/material";
import { Grid } from "@mui/material";

import AnimateButton from "@/components/@extended/AnimateButton";

import AuthenticationActionButton from "../components/authentication-action-button";
import {
  AuthenticationLinkExpiredContent,
  LinkExpiredContainer,
  LinkExpiredImage,
  LinkExpiredTitle,
} from "./LinkExpired.slots";

export default function AuthenticationLinkExpired() {
  return (
    <LinkExpiredContainer>
      <LinkExpiredImage />
      <LinkExpiredTitle>Aigency</LinkExpiredTitle>
      <AuthenticationLinkExpiredContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box sx={{ mb: { xs: -0.5, sm: 0.5 }, textAlign: "center" }}>
              <Typography variant="h2" sx={{ fontWeight: 700, lineHeight: "42px" }}>
                Link expired
              </Typography>
              <Typography color="secondary" sx={{ mb: 0.5, mt: 1.25 }}>
                Hey, it looks like you are too late to reset your password. But don’t worry, you can
                request a new link again.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <AnimateButton>
              <AuthenticationActionButton as="link" href="/auth/forgot-password">
                Request a new reset link
              </AuthenticationActionButton>
            </AnimateButton>
          </Grid>
        </Grid>
      </AuthenticationLinkExpiredContent>
    </LinkExpiredContainer>
  );
}
